import { render, staticRenderFns } from "./FoundationHeader.vue?vue&type=template&id=40d49321&"
import script from "./FoundationHeader.vue?vue&type=script&lang=js&"
export * from "./FoundationHeader.vue?vue&type=script&lang=js&"
import style0 from "./FoundationHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports